import { render, staticRenderFns } from "./BomMaker.vue?vue&type=template&id=2052fdba&scoped=true"
import script from "./BomMaker.vue?vue&type=script&lang=js"
export * from "./BomMaker.vue?vue&type=script&lang=js"
import style0 from "./BomMaker.vue?vue&type=style&index=0&id=2052fdba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052fdba",
  null
  
)

export default component.exports